/** Stable API reasons; unknown provider text is never an admission explanation. */
export const BILLING_ADMISSION_MESSAGES: Readonly<Record<string, string>> = {
  execution_required: 'The call is waiting for a verified execution receipt.',
  execution_conflict: 'This call already has an execution owner. Refresh its current status.',
  billing_paused: 'New calls are paused for this company.',
  billing_state_invalid: 'Billing configuration needs operator attention.',
  policy_unapproved: 'Billing activation is waiting for product-policy approval.',
  period_expired: 'The credit period has expired. Open Billing to review payment options.',
  insufficient_credits: 'There are not enough available credits to start another call.',
  reconciliation_required: 'Billing needs reconciliation before new calls can start.',
  concurrent_limit_reached: 'The simultaneous-call limit has been reached.',
  feature_not_entitled: 'The current plan does not include this call feature.',
};
export const billingErrorReason = (error: unknown): string | null => {
  if (!error || typeof error !== 'object' || !('data' in error)) return null;
  const data = error.data;
  return data && typeof data === 'object' && 'reason' in data && typeof data.reason === 'string'
    ? data.reason
    : null;
};
export const billingAdmissionErrorMessage = (error: unknown): string | null => {
  const reason = billingErrorReason(error);
  return reason && Object.prototype.hasOwnProperty.call(BILLING_ADMISSION_MESSAGES, reason)
    ? BILLING_ADMISSION_MESSAGES[reason]
    : null;
};
